









import Vue from 'vue'
import FontPicker from 'font-picker-vue'
import './FontSelector.scss'

export default Vue.extend({
  name: 'FontSelector',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  methods: {
    updateFont (font: { family: string }): void {
      this.$emit('input', font.family)
      this.$emit('change', font.family)
    }
  },
  components: {
    'font-picker': FontPicker
  }
})
